<ng-container *ngIf='contactImageUrl; else elseBlock' >
  <img [src]='contactImageUrl'
       [ngClass]='status'
       [style.height]="size"
       [style.width]="size" />
</ng-container>
<ng-template #elseBlock>
  <mat-icon id='person-icon'
            fxLayout="column"
            fxLayoutAlign="center center"
            [ngClass]='status'
            [style.height]="size"
            [style.width]="size"
            [style.font-size]="fontSize">
    person
  </mat-icon>
</ng-template>
